import React, { useEffect, useState } from 'react';

const CookiePreferencesButton = ({ className, children }) => {
	const [isClient, setIsClient] = useState(false);

	// useEffect only runs on the client side after hydration
	useEffect(() => {
		setIsClient(true);
	}, []);

	const handleOpenBanner = e => {
		e.preventDefault();

		if (!isClient || typeof window === 'undefined') return;

		const tryInvoke = (target, method) => {
			if (target && typeof target[method] === 'function') {
				target[method]();
				return true;
			}
			return false;
		};

		const pandectesGlobal = window.Pandectes
			|| window.pandectes
			|| window.PandectesCMP
			|| window.pandectesCmp;

		// Official Pandectes gist fallback.
		if (
			pandectesGlobal
			&& pandectesGlobal.fn
			&& typeof pandectesGlobal.fn.revokeConsent === 'function'
		) {
			pandectesGlobal.fn.revokeConsent();
			return;
		}

		// Current local runtime path.
		if (tryInvoke(pandectesGlobal, 'openDialog')) {
			pandectesGlobal.openDialog('preferences');
			return;
		}

		// Broad compatibility for older/newer global APIs.
		const globalMethods = [
			'openAdminModal',
			'openPreferences',
			'showPreferences',
			'openConsentPreferences',
			'open',
			'show',
			'reopen',
		];
		for (let i = 0; i < globalMethods.length; i += 1) {
			if (tryInvoke(pandectesGlobal, globalMethods[i])) {
				return;
			}
		}

		// Component fallback.
		const pandectesElement = document.querySelector('pandectes-cmp')
			|| document.querySelector('pandectes-banner')
			|| document.querySelector('pandectes-root');
		const elementMethods = ['openDialog', ...globalMethods];
		for (let j = 0; j < elementMethods.length; j += 1) {
			if (tryInvoke(pandectesElement, elementMethods[j])) {
				if (elementMethods[j] === 'openDialog') {
					pandectesElement.openDialog('preferences');
				}
				return;
			}
		}

		// Last fallback: click any configured #reopenBanner trigger.
		const customTriggerLink = document.querySelector('[href*="#reopenBanner" i]');
		if (customTriggerLink && typeof customTriggerLink.click === 'function') {
			customTriggerLink.click();
			return;
		}

		// Legacy hash fallback.
		window.location.hash = 'reopenBanner';
	};

	// Prevent rendering on SSR to maintain DOM alignment
	if (!isClient) {
		return null;
	}

	return (
		<button
			onClick={handleOpenBanner}
			className={className || 'cookie-pref-btn'}
			type={'button'}
		>
			{children || 'Cookie Preferences'}
		</button>
	);
};

export default CookiePreferencesButton;
